import HttpCliente from "../HttpCliente";

// Trae la suscripción del suscriptor (plan, estado, fechas, config).
export const getMiSuscripcion = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/SuscripcionSuscriptor/MiSuscripcion", {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

// Cancela la suscripción del suscriptor.
export const cancelarMiSuscripcion = (token, cancelToken) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post(
      "/SuscripcionSuscriptor/Cancelar",
      { cancelToken },
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};